// Must correspond to this:
// https://github.com/SourceSage/sourcesage-backend/blob/master/sourcesage/constants.py#L252
export const DAILY = 'daily';
export const WEEKLY = 'weekly';
export const MONTHLY = 'monthly';
export const QUARTERLY = 'quarterly';
export const YEARLY = 'yearly';
export enum Frequency {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  quarterly = 'quarterly',
  yearly = 'yearly',
}
export enum Currency {
  EUR = 'EUR',
  GBP = 'GBP',
  RMB = 'RMB',
  SGD = 'SGD',
  USD = 'USD',
  INR = 'INR',
  MYR = 'MYR',
  THB = 'THB',
}



// WEBPACK FOOTER //
// ./app/constants/TRADES.ts